'use client';

import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card } from "reactstrap";
import { Breadcrumbs } from "../../AbstractElements";
import { useForm } from "react-hook-form";
import { Pencil, AlertCircle, Building2, Globe, MapPin, DollarSign } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { useLoader } from "../../_helper/LoaderContext";
import { toast } from "react-toastify";
import { useLab } from "../../_helper/PharmacyProvider";
import { Tooltip } from "react-tooltip";
import { addLabUser, generate } from "./service/user-service";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Controller } from "react-hook-form";
import { cityMaster, districtMaster, pincodeMaster, stateMaster } from "../LabProfile/service/profile-service";

export default function AddUser() {
    const [profileImage, setProfileImage] = useState(null); // Base64 preview
    const [profileImageFile, setProfileImageFile] = useState(null);
    const [imageError, setImageError] = useState("");
    const { currentLab } = useLab()
    const { setLoading } = useLoader();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        country: "IN",
        state: "",
        district: "",
        city: "",
        pincode: ""
    });
    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
        setValue,
        trigger,
        control
    } = useForm();

    useEffect(() => {

    },[])


    const handleImageUpload = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        if (file.size > 5 * 1024 * 1024) {
            setImageError("File size must be less than 5MB");
            return;
        }

        if (!["image/jpeg", "image/jpg", "image/png", "image/gif"].includes(file.type)) {
            setImageError("Only JPG, PNG, or GIF files are allowed");
            return;
        }

        setImageError("");
        setProfileImageFile(file);

        const reader = new FileReader();
        reader.onloadend = () => {
            setProfileImage(reader.result);
        };
        reader.readAsDataURL(file);
    };

    const onSubmit = async (data) => {
        setLoading(true);
        try {
            const form_Data = new FormData();
            form_Data.append("first_name", data.firstName);
            form_Data.append("last_name", data.lastName);
            form_Data.append("facility_name", currentLab.facility_name);
            form_Data.append("email", currentLab.email);
            form_Data.append("contact_email", data.email);
            form_Data.append("password", data.password);
            form_Data.append("mobile", data.mobile);
            form_Data.append("address", currentLab?.contact_person.address);
            form_Data.append("createdById", currentLab?._id);
            form_Data.append("labId", currentLab?._id);
            form_Data.append("country", currentLab?.contact_person.country);
            form_Data.append("state", currentLab?.contact_person.state);
            form_Data.append("city", currentLab?.contact_person.city);
            form_Data.append("district", currentLab?.contact_person.district);
            if (profileImageFile) {
                form_Data.append("profilePicture", profileImageFile);
            }
            const res = await addLabUser(form_Data)
            if (res.data.success == true) {
                toast.success(res.data.message);
                navigate(`${process.env.PUBLIC_URL}/user`)
            }
        } catch (error) {
            // toast.warning("Failed to add user");
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const generetPassword = async () => {
        setLoading(true);
        try {
            const res = await generate();
            // console.log(res)
            if (res.data.success == true) {
                const generatedPassword = res.data.data.password;
                setValue("password", generatedPassword);
                // trigger("password");
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <Breadcrumbs mainTitle="Add User" parent="Home" subParent="List Of User" title="Add User" />
            <Container fluid={true}>
                <Row>
                    <Col>
                        <Card className="tw-shadow-xl tw-rounded-2xl tw-border-0 tw-bg-white tw-p-8">
                            <div className="card-body">
                                <div className="row">
                                    {/* Left: Profile Image */}
                                    <div className="col-md-4 tw-flex tw-flex-col tw-items-center tw-border-r tw-border-gray-200">
                                        {/* ... (profile image section unchanged) ... */}
                                        <div className="tw-mb-6">
                                            <div className="tw-relative tw-inline-block">
                                                <label htmlFor="profile-upload" className="tw-cursor-pointer tw-block">
                                                    <div className="tw-w-40 tw-h-40 tw-rounded-full tw-overflow-hidden tw-bg-gray-100 tw-border-4 tw-border-dashed tw-border-gray-300 tw-flex tw-items-center tw-justify-center hover:tw-border-primary tw-transition-all tw-duration-300">
                                                        {profileImage ? (
                                                            <img src={profileImage} alt="Profile" className="tw-w-full tw-h-full tw-object-cover" />
                                                        ) : (
                                                            <div className="tw-text-center">
                                                                <Globe className="tw-w-16 tw-h-16 tw-text-gray-400 tw-mx-auto" />
                                                                <p className="tw-text-gray-500 tw-text-sm tw-mt-2">Click to upload</p>
                                                            </div>
                                                        )}
                                                    </div>
                                                </label>
                                                <label htmlFor="profile-upload" className="tw-absolute tw-bottom-2 tw-right-2 bg-primary tw-rounded-full tw-p-2 tw-shadow-md tw-cursor-pointer tw-flex tw-items-center tw-justify-center tw-w-9 tw-h-9 tw-border-2 tw-border-white">
                                                    <Pencil className="tw-w-4 tw-h-4 tw-text-white" />
                                                </label>
                                                <input id="profile-upload" type="file" accept="image/jpeg,image/jpg,image/png,image/gif" onChange={handleImageUpload} className="tw-hidden" />
                                            </div>
                                            {imageError && (
                                                <div className="tw-flex tw-items-center tw-gap-2 tw-text-red-600 tw-text-sm tw-mt-3">
                                                    <AlertCircle className="tw-w-4 tw-h-4" />
                                                    <span>{imageError}</span>
                                                </div>
                                            )}
                                            <p className="tw-text-gray-500 tw-text-xs tw-mt-2">Upload Profile Image</p>
                                        </div>
                                        {/* Lab Info */}
                                        <div className="tw-w-full tw-rounded-xl tw-p-4 tw-mt-6" style={{ border: "1px solid #1b255b" }}>
                                            <h6 className="tw-font-semibold tw-text-gray-700 tw-mb-3 tw-flex tw-items-center tw-gap-2">
                                                <Building2 className="tw-w-5 tw-h-5" />
                                                Laboratory Info
                                            </h6>
                                            <div className="tw-space-y-3 tw-text-sm">
                                                <div className="tw-flex tw-justify-between">
                                                    <span className="tw-text-gray-600">Lab Name:</span>
                                                    <span className="tw-font-medium">{currentLab?.facility_name}</span>
                                                </div>
                                                <div className="tw-flex tw-justify-between tw-items-center">
                                                    <span className="tw-text-gray-600">Base Currency:</span>
                                                    <span className="tw-font-bold tw-text-primary">{currentLab?.baseCurrency}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Right: Form Fields */}
                                    <div className="col-md-8 tw-ps-5">
                                        <form className="tw-space-y-5" onSubmit={handleSubmit(onSubmit)}>
                                            {/* Name Row */}
                                            <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4">
                                                <div>
                                                    <label className="tw-block tw-font-medium tw-mb-1">First Name <span className="tw-text-red-500">*</span></label>
                                                    <input type="text" className="form-control" placeholder="Enter first name" {...register("firstName", { required: "First name is required" })} />
                                                    {errors.firstName && <p className="tw-text-red-500 tw-text-xs tw-mt-1">{errors.firstName.message}</p>}
                                                </div>
                                                <div>
                                                    <label className="tw-block tw-font-medium tw-mb-1">Last Name <span className="tw-text-red-500">*</span></label>
                                                    <input type="text" className="form-control" placeholder="Enter last name" {...register("lastName", { required: "Last name is required" })} />
                                                    {errors.lastName && <p className="tw-text-red-500 tw-text-xs tw-mt-1">{errors.lastName.message}</p>}
                                                </div>
                                            </div>

                                            {/* Email & Mobile */}
                                            <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4">
                                                <div>
                                                    <label className="tw-block tw-font-medium tw-mb-1">Email <span className="tw-text-red-500">*</span></label>
                                                    <input type="email" className="form-control" placeholder="Enter email" {...register("email", { required: "Email is required", pattern: { value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, message: "Invalid email" } })} />
                                                    {errors.email && <p className="tw-text-red-500 tw-text-xs tw-mt-1">{errors.email.message}</p>}
                                                </div>
                                                <div>
                                                    <label className="tw-block tw-font-medium tw-mb-1">Mobile Number <span className="tw-text-red-500">*</span></label>
                                                    <Controller
                                                        name="mobile"
                                                        control={control}
                                                        rules={{ required: "Mobile is required" }}
                                                        render={({ field }) => (
                                                            <PhoneInput {...field} country="in" enableSearch placeholder="+91 9876543210" inputClass="form-control" inputStyle={{ width: "100%" }} onChange={(value) => field.onChange(value)} />
                                                        )}
                                                    />
                                                    {errors.mobile && <p className="tw-text-red-500 tw-text-xs tw-mt-1">{errors.mobile.message}</p>}
                                                </div>
                                            </div>



                                            {formData.country === "OTHER" && (
                                                <div>
                                                    <label className="tw-block tw-font-medium tw-mb-1">Country Name</label>
                                                    <input type="text" className="form-control" placeholder="Enter country" {...register("country")} />
                                                </div>
                                            )}
                                            {/* {formData.country === "IN" && (
                                                <>
                                                    <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4">

                                                        <div>
                                                            <label className="tw-block tw-font-medium tw-mb-1">Country <span className="tw-text-red-500">*</span></label>
                                                            <select
                                                                className="form-control"
                                                                value={formData.country}
                                                                onChange={(e) => setFormData(prev => ({ ...prev, country: e.target.value }))}
                                                            >
                                                                <option value="IN">India</option>
                                                            </select>
                                                        </div>

                                                        <div>
                                                            <label className="tw-block tw-font-medium tw-mb-1">State <span className="tw-text-red-500">*</span></label>
                                                            <select
                                                                className="form-control"
                                                                value={formData.state}
                                                                onChange={(e) => setFormData(prev => ({ ...prev, state: e.target.value }))}
                                                                disabled={loadingLocation}
                                                            >
                                                                <option value="">Select State</option>
                                                                {states.map((s) => (
                                                                    <option key={s._id} value={s.State}>
                                                                        {s.State}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>

                                                    </div>
                                                    
                                                    <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4">
                                                        <div>
                                                            <label className="tw-block tw-font-medium tw-mb-1">District <span className="tw-text-red-500">*</span></label>
                                                            <select
                                                                className="form-control"
                                                                value={formData.district}
                                                                onChange={(e) => setFormData(prev => ({ ...prev, district: e.target.value }))}
                                                                disabled={loadingLocation || districts.length === 0}
                                                            >
                                                                <option value="">Select District</option>
                                                                {districts.map((d) => (
                                                                    <option key={d._id} value={d.District}>
                                                                        {d.District}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <div>
                                                            <label className="tw-block tw-font-medium tw-mb-1">City <span className="tw-text-red-500">*</span></label>
                                                            <select
                                                                className="form-control"
                                                                value={formData.city}
                                                                onChange={(e) => setFormData(prev => ({ ...prev, city: e.target.value }))}
                                                                disabled={loadingLocation || cities.length === 0}
                                                            >
                                                                <option value="">Select City</option>
                                                                {cities.map((c) => (
                                                                    <option key={c._id} value={c.City}>
                                                                        {c.City}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>

                                                    </div>
                                                </>
                                            )} */}
                                            <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4">
                                                {/* <div>
                                                    <label className="tw-block tw-font-medium tw-mb-1">Pincode</label>
                                                    <input className="form-control" value={formData.pincode}
                                                        onChange={(e) => setFormData(prev => ({ ...prev, pincode: e.target.value }))}
                                                        placeholder="Enter pincode" />                                                  
                                                </div> */}
                                                <div>
                                                    <label className="tw-block tw-font-medium tw-mb-1">Password <span className="tw-text-red-500">*</span></label>
                                                    <div className="input-group">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter Password"
                                                            {...register("password", { required: "Password is required" })}
                                                        />
                                                        <span className="input-group-text tw-cursor-pointer" onClick={generetPassword} data-tooltip-id="generate">
                                                            <i className="bi bi-lock-fill"></i>
                                                        </span>
                                                        <Tooltip id="generate" place="top" content="Auto Generate Password" />
                                                    </div>
                                                    {errors.password && <p className="tw-text-red-500 tw-text-xs tw-mt-1">{errors.password.message}</p>}
                                                </div>
                                            </div>
                                            {/* <div>
                                                <label className="tw-block tw-font-medium tw-mb-1">Address</label>
                                                <textarea rows="3" className="form-control" placeholder="Enter address" {...register("address")} />
                                            </div> */}

                                            {/* Submit Buttons */}
                                            <div className="tw-flex tw-justify-end tw-gap-3 tw-mt-8">
                                                <button type="submit" disabled={isSubmitting} className="btn btn-primary tw-px-8">
                                                    {isSubmitting ? "Saving..." : "Add User"}
                                                </button>
                                                <Link to={`${process.env.PUBLIC_URL}/user`}>
                                                    <button type="button" className="btn btn-secondary">Cancel</button>
                                                </Link>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
}